module.exports = __webpack_public_path__ + "assets/img/thumb-Artboard-1-copy-31.29296184.jpg";